import React, { useContext } from 'react'
import { ContentFooter } from '../../layout/Content'
import RecordNavigator from '../../layout/RecordNavigator'
import ReceiptsListFooterStyle from './css/ReceiptsListFooterStyle'
import { receiptsListControllerContext } from './ReceiptsListController'

function ReceiptsListFooter() {
  const receiptsListController = useContext(receiptsListControllerContext)
  const [recPP, setRecPP] = receiptsListController.recPP
  const [page, setPage] = receiptsListController.page
  const [recordPerPage, setRecordPerPage] = receiptsListController.recordPerPage
  const { totalPage, getTotalRecords } = receiptsListController

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    totalPage, getTotalRecords
  }

  return (
    <ContentFooter>
      <div id='receipts-list-footer-container'>
        <RecordNavigator { ...recordNavigatorProps }/>
      </div>
      <ReceiptsListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(ReceiptsListFooter)
